// extracted by mini-css-extract-plugin
export default {"useradmin-paper":"admin-paper__useradmin-paper--iozuB","useradminPaper":"admin-paper__useradmin-paper--iozuB"};